export default {
  title: "",
  subtitle: "",
  path: "conversion_under_request_confirmation",
  paragraphs: [
    "After requesting this type of exchange, you will need to confirm it using this endpoint:" 
  ],
  troubleshooting: {
    title: 'Common mistakes',
    messages: [
      {
        description: 'Transaction was not identified',
        code: {
      "error": [
          {
            "error": "transaction_not_identified",
            "description": "All transactions must have been identified before exchanged"
          }
        ]
      }
      }
    ]
  },
  request: {
    method: "POST",
    endpoint: "/exchanges",
    payload:
     { 
     "exchange": { 
         "transaction_ids": [ 
             "d8af89f2-7888-4357-b5e2-3ca5ddc80c92" 
         ] 
      } 
    },
    responses:{
      "data": {
          "value": "1250.00",
          "user": {
              "name": "Partner Test",
              "id": "dc6630a3-43c7-4286-bb47-4ebeb39c4b18",
              "email": "partner@mail.com"
          },
          "to_bank_account": {
              "routing_number": null,
              "pix_info": {
                  "type": "EMAIL",
                  "key": "email@teste.com"
              },
              "owner_name": "André Freitas Lopes",
              "owner_document_type": "cpf",
              "owner_document_number": "01472583691",
              "nickname": null,
              "intermediary_bank_account_id": null,
              "id": "c3d8b7e8-4022-4ce6-9d45-c4666ea53653",
              "iban": null,
              "currency": "BRL",
              "company": {
                  "social_name": "John Doe",
                  "phone_number": "99812-1212",
                  "id": "01e0725b-b4f5-46b1-811a-a3cbcb314d10",
                  "fiscal_country": "BR",
                  "document_type": "cpf",
                  "document_number": "05069869183",
                  "company_name": "Company & CIA"
              },
              "branch_number": null,
              "branch_country": "BR",
              "bank": {
                  "swift": "BCBPIXEMAIL000",
                  "name": "PIX Key - EMAIL",
                  "ispb": null,
                  "id": "979657bc-494f-4642-849a-7e171ebc742b",
                  "country": null,
                  "code": null
              },
              "account_type": "conta-corrente",
              "account_number": null,
              "aba": null
          },
          "iof_value": "28.05",
          "iof_rate": "0.0038",
          "inserted_at": "2025-07-09T19:27:17.891325",
          "id": "dd5e4988-66b3-457d-8024-fc3f094bb1fc",
          "fx_value": "101.6",
          "fx_rate": "0.01",
          "exchanged_value": "7280.9",
          "exchange_rate_spot": "5.90600000",
          "exchange_rate": "5.82472",
          "exchange_currency": "BRL",
          "currency": "USD",
          "bank_transactions": [
              {
                  "wire_id": null,
                  "value": "1250",
                  "source_type": "WIRE",
                  "source_name": "John Doe",
                  "source_id": null,
                  "source_document_type": "cpf",
                  "source_document_number": "05069869183",
                  "source_description": "CREDITO POR TED",
                  "source_branch": "1142",
                  "source_bank_ispb": null,
                  "source_bank": "033",
                  "source_account": "130013844",
                  "movement_date": "2025-07-09",
                  "iof_value": "28.05",
                  "id": "7c7203c8-a1e3-4a7d-996f-600e80939c02",
                  "fx_value": "101.60",
                  "exchanged_value": "7280.90",
                  "exchange_rate": "5.82472",
                  "exchange_id": "dd5e4988-66b3-457d-8024-fc3f094bb1fc",
                  "exchange_currency": "BRL",
                  "exchange_approved": false,
                  "currency": "USD",
                  "company_name": "Gustavo Rodrigues Paludetto",
                  "company_id": "d6db1129-0ed3-4da7-9beb-d8c6326465f2"
              }
          ],
        "approved_by": null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionConverionUnderConfirmExchange.js